import { fonts, colors, screen } from 'components/styles/variables';
import LoadingSpinner from 'components/Shared/LoadingSpinner';
import { useTranslation } from 'react-i18next';
import { LargeButton } from 'components/Shared/Buttons';
import Spacer from 'components/Shared/Spacer';
import css from 'styled-jsx/css';
import { useMedia } from 'react-use';
import { SMALL } from 'lib/DeviceScreen';
import styles from './styles';

const buttonCss = css.resolve`
  flex-grow: 1;
  flex-basis: 0;
  height: 44px;
  font-size: 16px;
  padding: 9px 0px 11px 0px;

  @media (min-width: ${screen.smMin}) {
    height: 56px;
    font-size: 18px;
    padding: 13px 0px 16px 0px;
  }
`;

function LoadingCard(): JSX.Element {
  const { t } = useTranslation();
  const isMobile = useMedia(`(max-width: ${SMALL.cssMaxWidth})`);
  return (
    <div className="loading-card" data-testid="loading-card">
      <div className="quick-picks-header">
        <div className="quick-picks-title">{t('vdp.buyersViewed')}</div>
      </div>
      <div className="loading-image-container">
        <div className="gray-background bar-animation">
          <LoadingSpinner containerSize={64} spinnerSize={36} isWhite={false} />
        </div>
      </div>
      <div className="bars">
        <div className="gray-bars-container">
          <div className="larger gray-bar bar-animation" />
          <div className="smaller gray-bar bar-animation" />
        </div>
        <div className="gray-bars-container">
          <div className="medium gray-bar bar-animation" />
          <div className="smallest gray-bar bar-animation" />
        </div>
        <div className="gray-bars-container">
          <div className="larger gray-bar bar-animation" />
          <div className="smaller gray-bar bar-animation" />
        </div>
      </div>
      <div className="quick-picks-actions">
        <LargeButton disabled={true} isGray={true} className={buttonCss.className}>
          {t('quickPicks.skip')}
        </LargeButton>
        <Spacer size="16px" smSize="24px" />
        <LargeButton disabled={true} className={buttonCss.className}>
          {isMobile ? t('quickPicks.oneTapContact') : t('quickPicks.oneClickContact')}
        </LargeButton>
      </div>
      <style jsx>{styles}</style>
      <style jsx>
        {`
          .loading-card {
            position: absolute;
            bottom: 0;
            font-family: ${fonts.default};
            display: flex;
            flex-direction: column;
            max-width: 288px;
            width: 100%;
            padding-bottom: 16px;
          }

          @media (min-width: ${screen.smMin}) {
            .loading-card {
              max-width: 600px;
              padding-bottom: 24px;
            }
          }

          .loading-image-container {
            margin-bottom: 24px;
          }

          @media (min-width: ${screen.smMin}) {
            .loading-image-container {
              margin-bottom: 32px;
            }
          }

          .gray-background {
            background-color: ${colors.G2};
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 16px;
            width: 100%;
            height: 157px;
            background-position: 0px 0px;
          }

          @media (min-width: ${screen.smMin}) {
            .gray-background {
              height: 326px;
            }
          }

          .bars {
            padding-bottom: 14px;
            border-bottom: 1px solid ${colors.G1};
            margin-bottom: 16px;
          }

          @media (min-width: ${screen.smMin}) {
            .bars {
              padding-bottom: 16px;
              margin-bottom: 24px;
            }
          }
          .bar-animation {
            background: linear-gradient(90deg, ${colors.G1} 0%, ${colors.G2} 40%, ${colors.G1} 60%);
            background-size: 900% 900%;
            animation: BarAnimation 1.2s ease infinite;
          }

          .gray-bar {
            height: 12px;
            border-radius: 4px;
          }

          @media (min-width: ${screen.smMin}) {
            .gray-bar {
              height: 16px;
            }
          }

          .gray-bars-container {
            display: flex;
            justify-content: space-between;
            margin: 0px 0 10px 0;
          }

          @media (min-width: ${screen.smMin}) {
            .gray-bars-container {
              margin-bottom: 16px;
            }
          }

          .larger {
            width: 183px;
          }

          .medium {
            width: 141px;
          }

          .smaller {
            width: 61px;
          }

          .smallest {
            width: 47px;
          }

          @media (min-width: ${screen.smMin}) {
            .larger {
              width: 359px;
            }

            .medium {
              width: 316px;
            }

            .smaller {
              width: 139px;
            }

            .smallest {
              width: 112.5px;
            }
          }

          @keyframes BarAnimation {
            0% {
              background-position: 100% 100%;
            }
            100% {
              background-position: 0% 0%;
            }
          }

          .disabled {
            background-color: ${colors.G1};
            color: ${colors.G2};
          }
        `}
      </style>
      {buttonCss.styles}
    </div>
  );
}

export default LoadingCard;
